import { Plan } from "../../../@types";

export const getPlanNameElementId = (plan: Plan): string => {
  return `plan_name_${plan.id}`;
};
